import { Grid, IconButton } from '@material-ui/core';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import SearchIcon from '@mui/icons-material/Search';
import { useCallback, useState, useEffect } from 'react';
import { OnChange } from 'react-final-form-listeners';
import { useDispatch, useSelector } from 'react-redux';
import { fetchByFilterAsync, fetchByProdutosPortalUnicoAsync, selectCatalogosProdutos } from '../../features/catalogo-produtos/catalogoProdutosSlice';
import {
  TIPO_FATURA,
} from '../../utils/general/fatura/faturaUtils';
import QCXProdutoAutocomplete from './QCXProdutoAutocomplete';
import useGetFilterByProdutoType from './useGetFiltersByProdutoType.hook';

export default function QCXSelectProdutoAutocomplete({
  label,
  name,
  form,
  initialValues,
  tipo = TIPO_FATURA,
  partnumber,
  idFatura,
  isDIDUIMP,
  isTipoDeclaracaoDuimp,
  ...restProps
}) {
  const dispatch = useDispatch();
  const list = useSelector(selectCatalogosProdutos);
  const filters = useGetFilterByProdutoType(tipo);

  const [inputValue, setInputValue] = useState(' ');

  // Existe um listener no formulario que precisa ser acionado quando o partnumber muda
  // (handlePartnumberSelectorOnchange no arquivo faturaMercadoriaListeners.js)
  // não é possivel aciona-lo manualmente, para forcar a execução tive que mudar o partnumber para ""
  // e depois carregar o novo valor, o preSearch serve para quando o valor não é encontrado
  const [preSearch, setPreSearch] = useState('');

  useEffect(() => {
    if (partnumber) {
      setInputValue(partnumber);
    } else {
      setInputValue('');
    }
  }, [partnumber]);

  const handleSetInputValue = (_event, newInputValue, reason) => {
    if (reason !== 'clear') {
      setInputValue(newInputValue);
      form.change('partnumberAutocompleteSelector', newInputValue);
      form.change('partNumber', newInputValue);
      return;
    }

    form.change('partnumberAutocompleteSelector', undefined);
    form.change('partNumberSelector', undefined);
    form.change('partNumber', undefined);
  };

  const handleFilter = useCallback(
    (filterValue) => {
      setPreSearch(filterValue);
      form.change('partnumberAutocompleteSelector', undefined);

      dispatch(fetchByFilterAsync([...filters, { name: 'partnumber', value: filterValue }]));
    },
    [filters]
  );

  const handleSearch = useCallback(
    (filterValue) => {
      console.log("handleSearch")
      if (idFatura && isDIDUIMP && isTipoDeclaracaoDuimp) {
        dispatch(fetchByProdutosPortalUnicoAsync([...filters, { name: 'partnumber', value: filterValue}, { name: 'search', value: true }, {name: 'idfatura', value: idFatura}]));
      } else if (filterValue) {
        dispatch(fetchByFilterAsync([...filters, { name: 'partnumber', value: filterValue }, { name: 'search', value: true }]));
      }
    },
    [filters]
  );

  useEffect(() => {
    if (preSearch === '' || list.length !== 1) {
      form.change('partnumberAutocompleteSelector', preSearch);
      return;
    }

    form.change('partnumberAutocompleteSelector', list[0].partnumber);
  }, [list]);

  const filterOptions = createFilterOptions({
    stringify: (option) => option.partnumber,
  });

  const getOptionLabelConditional = (item) => {
    if (idFatura && isDIDUIMP && isTipoDeclaracaoDuimp) {
      return `${item?.partnumber}`
    }
    
    return item?.partnumber;
  }

  return (
    <Grid container alignItems="center">
      <Grid xs={11}>
        <QCXProdutoAutocomplete
          id={name}
          name={name}
          label={label}
          options={list}
          // onBlurCallback={(filterValue) => handleFilter(filterValue)}
          onBlurCallback={(filterValue) => true}
          filterOptions={filterOptions}
          initialValues={initialValues}
          inputValue={inputValue}
          handleSetInputValue={handleSetInputValue}
          getOptionLabel={(item) => getOptionLabelConditional(item)}
          form={form}
          {...restProps}
        />
      </Grid>
      <Grid xs={1}>
        <IconButton onClick={() => handleSearch(inputValue)} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Grid>

      <OnChange name={name}>
        {(value, previous) => {
          if (!value) return;
          if (idFatura && isDIDUIMP && isTipoDeclaracaoDuimp) {
            const catalogo = list.find((el) => el.partnumber === value);
            if (catalogo) {
              form.change('versaoCatalogo', catalogo.versao);
              form.change('codigoCatalogo', catalogo.codigoIntegracao);
            }
          } else {
            const catalogo = list.find((el) => el.partnumber === value);
            if (catalogo) {
              form.change('naladiSh.id', catalogo?.naladiSh?.id);
            }
          }
        }}
      </OnChange>
    </Grid>
  );
}
